import type { TranslationKey } from "../../i18n/translations";

export type ProjectCategoryId =
    | "cybercrime"
    | "public-safety"
    | "digital-society"
    | "digital-transformation";

export interface ProjectCategoryItem {
    titleKey: TranslationKey;
    descKey: TranslationKey;
}

export interface ProjectCategoryDefinition {
    id: ProjectCategoryId;
    path: string;
    titleKey: TranslationKey;
    subtitleKey: TranslationKey;
    summaryKey: TranslationKey;
    backgroundIcon: string;
    cardPreviewTitleKeys: TranslationKey[];
    items: ProjectCategoryItem[];
}

const PUBLIC_URL = process.env.PUBLIC_URL;

export const PROJECT_CATEGORIES: ProjectCategoryDefinition[] = [
    {
        id: "cybercrime",
        path: "/projekty/cyberbezpieczenstwo-i-przestepczosc-cyfrowa",
        titleKey: "projects_topic_cybercrime_title",
        subtitleKey: "projects_topic_cybercrime_subtitle",
        summaryKey: "projects_topic_cybercrime_summary",
        backgroundIcon: `${PUBLIC_URL}/cybesec.png`,
        cardPreviewTitleKeys: [
            "projects_topic_item_phishing_title",
            "projects_topic_item_illegal_goods_title",
            "projects_topic_item_media_title",
        ],
        items: [
            {
                titleKey: "projects_topic_item_phishing_title",
                descKey: "planned_proj_phishing_desc",
            },
            {
                titleKey: "projects_topic_item_illegal_goods_title",
                descKey: "planned_proj_illegal_goods_desc",
            },
            {
                titleKey: "projects_topic_item_media_title",
                descKey: "planned_proj_media_desc",
            },
            {
                titleKey: "projects_topic_item_justice_title",
                descKey: "planned_proj_justice_desc",
            },
            {
                titleKey: "projects_topic_item_environment_title",
                descKey: "planned_proj_environment_desc",
            },
        ],
    },
    {
        id: "public-safety",
        path: "/projekty/bezpieczenstwo-publiczne-i-infrastruktura-krytyczna",
        titleKey: "projects_topic_public_title",
        subtitleKey: "projects_topic_public_subtitle",
        summaryKey: "projects_topic_public_summary",
        backgroundIcon: `${PUBLIC_URL}/secure.png`,
        cardPreviewTitleKeys: [
            "projects_topic_item_documents_title",
            "projects_topic_item_missing_title",
            "projects_topic_item_border_title",
        ],
        items: [
            {
                titleKey: "projects_topic_item_documents_title",
                descKey: "planned_proj_documents_desc",
            },
            {
                titleKey: "projects_topic_item_missing_title",
                descKey: "planned_proj_missing_desc",
            },
            {
                titleKey: "projects_topic_item_border_title",
                descKey: "planned_proj_border_desc",
            },
            {
                titleKey: "projects_topic_item_comms_title",
                descKey: "planned_proj_comms_desc",
            },
        ],
    },
    {
        id: "digital-society",
        path: "/projekty/spoleczenstwo-cyfrowe-kultura-i-regulacje",
        titleKey: "projects_topic_society_title",
        subtitleKey: "projects_topic_society_subtitle",
        summaryKey: "projects_topic_society_summary",
        backgroundIcon: `${PUBLIC_URL}/net.png`,
        cardPreviewTitleKeys: [
            "projects_topic_item_wcag_title",
            "projects_topic_item_deepfake_title",
            "projects_topic_item_skg_title",
        ],
        items: [
            {
                titleKey: "projects_topic_item_wcag_title",
                descKey: "planned_proj_wcag_desc",
            },
            {
                titleKey: "projects_topic_item_deepfake_title",
                descKey: "planned_proj_deepfake_desc",
            },
            {
                titleKey: "projects_topic_item_skg_title",
                descKey: "planned_proj_skg_desc",
            },
        ],
    },
    {
        id: "digital-transformation",
        path: "/projekty/transformacja-cyfrowa-innowacje-i-wspolpraca",
        titleKey: "projects_topic_business_title",
        subtitleKey: "projects_topic_business_subtitle",
        summaryKey: "projects_topic_business_summary",
        backgroundIcon: `${PUBLIC_URL}/buisness.png`,
        cardPreviewTitleKeys: [
            "projects_topic_item_academic_title",
            "projects_topic_item_mapping_title",
            "projects_topic_item_ria_title",
        ],
        items: [
            {
                titleKey: "projects_topic_item_academic_title",
                descKey: "planned_proj_academic_desc",
            },
            {
                titleKey: "projects_topic_item_mapping_title",
                descKey: "planned_proj_mapping_desc",
            },
            {
                titleKey: "projects_topic_item_ria_title",
                descKey: "planned_proj_ria_desc",
            },
        ],
    },
];

export const getProjectCategoryById = (
    categoryId: ProjectCategoryId
): ProjectCategoryDefinition | undefined =>
    PROJECT_CATEGORIES.find((category) => category.id === categoryId);
